import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import AsyncComponent from '@homeaway/react-async-component';
import Modal from '@homeaway/react-modal';
import {withSystemContext} from '@homeaway/catalyst-globalization-configuration';

const placeholder = (
    <Modal id="login-experience" isOpen header={false} isLoading onClose={() => {}} />
);

const mapStateToProps = ({
    systemReducer: {
        marketingOptInType: {sign_up: signUp}
    }
}) => ({
    preferenceType: signUp
});

@connect(mapStateToProps)
class LoginExperience extends Component {
    static propTypes = {
        actionLocation: PropTypes.string,
        locale: PropTypes.string.isRequired,
        onSuccess: PropTypes.func,
        onClose: PropTypes.func,
        readableSiteName: PropTypes.string.isRequired,
        setLoginModalClosed: PropTypes.func,
        setUserLoggedIn: PropTypes.func,
        siteName: PropTypes.string.isRequired,
        preferenceType: PropTypes.string.isRequired
    };

    static defaultProps = {
        locale: 'en_US_HA',
        onSuccess: () => {},
        onClose: () => {},
        readableSiteName: 'HomeAway',
        setLoginModalClosed: () => {},
        setUserLoggedIn: () => {},
        siteName: 'homeaway_us',
        context: 'base'
    };

    constructor(props) {
        super(props);
    }

    onCloseModal = () => {
        const {onClose, setLoginModalClosed} = this.props;

        setLoginModalClosed();
        onClose();
    };

    onLoginSuccess = ({publicUuid}) => {
        const {onSuccess, setUserLoggedIn} = this.props;
        if (publicUuid) {
            window.analyticsdatalayer.publicuuid = publicUuid;
        }
        setUserLoggedIn({isLoggedIn: true});
        onSuccess();
    };

    render() {
        const {
            actionLocation,
            readableSiteName,
            useNewEndpoints,
            context,
            name,
            locale,
            preferenceType
        } = this.props;
        const LEX = () => null;

        return (
            <React.Fragment>
                <AsyncComponent
                    importComponent={LEX}
                    importFunc={() => {
                        return import(/* webpackChunkName: "LEX" */ '@homeaway/react-lex');
                    }}
                    placeholder={placeholder}
                >
                    <LEX
                        actionLocation={actionLocation}
                        modalMode
                        configContext={context}
                        locale={locale}
                        site={name}
                        siteName={readableSiteName}
                        handleCloseModal={this.onCloseModal}
                        handleLoginSuccess={this.onLoginSuccess}
                        useNewEndpoints={useNewEndpoints}
                        preferenceType={preferenceType}
                        preferencePageType="pdp"
                    />
                </AsyncComponent>
            </React.Fragment>
        );
    }
}

export default withSystemContext(LoginExperience);
